import {
  deleteUserStorageItems,
  getUserStorageList,
  setUserStorageItems,
  userStorageItems,
} from 'api/userStorage';
import { LocalStorage, LocalStorageKeys } from 'helpers/localStorage';

// one item per opted-out lottery, so the choice holds on every device
const OPT_OUT_PREFIX = 'lottery_opt_out_';

const getLocalStorage = (userId: number) =>
  new LocalStorage<number[], number[]>(
    `${LocalStorageKeys.LotteryOptOuts}-${userId}`,
    []
  );

export const getOptOutIds = async (
  userId: number,
  isServerStorageEnabled: boolean
): Promise<number[]> => {
  const localIds = getLocalStorage(userId).get();

  if (!isServerStorageEnabled) return localIds;

  try {
    const { data } = await userStorageItems();

    return getUserStorageList(data)
      .filter(({ identifier }) => identifier.startsWith(OPT_OUT_PREFIX))
      .map(({ identifier }) => Number(identifier.slice(OPT_OUT_PREFIX.length)));
  } catch {
    return localIds;
  }
};

export const saveOptOut = async (
  userId: number,
  isServerStorageEnabled: boolean,
  lotteryId: number,
  isOptOut: boolean
): Promise<void> => {
  try {
    const storage = getLocalStorage(userId);
    const ids = storage.get().filter((id) => id !== lotteryId);

    storage.replace(isOptOut ? [...ids, lotteryId] : ids);
  } catch {}

  if (!isServerStorageEnabled) return;

  const identifier = `${OPT_OUT_PREFIX}${lotteryId}`;

  try {
    if (isOptOut) {
      await setUserStorageItems([
        { identifier, info: { opted_out_at: new Date().toISOString() } },
      ]);
    } else {
      await deleteUserStorageItems([identifier]);
    }
  } catch {}
};
